import { HttpClient, parseJSONApiResponse } from '@opallabs/api'
import loadMomentAccessGroupMembers from '../loadMomentAccessGroupMembers'

const fetchMomentAccessGroupMembers = (momentId) =>
  HttpClient().get(
    `/api/v1/moments/${momentId}/access_group/members/new?include=user,user.avatar`
  )

const getMomentAccessGroupMembers = (momentId) => (dispatch) =>
  fetchMomentAccessGroupMembers(momentId)
    .then((response) =>
      dispatch(
        loadMomentAccessGroupMembers({
          moment_id: momentId,
          data: parseJSONApiResponse(response.data),
        })
      )
    )
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getMomentAccessGroupMembers
